import { render, staticRenderFns } from "./EstadoMaquinaNyx.vue?vue&type=template&id=63b25c57&scoped=true&"
import script from "./EstadoMaquinaNyx.vue?vue&type=script&lang=js&"
export * from "./EstadoMaquinaNyx.vue?vue&type=script&lang=js&"
import style0 from "./EstadoMaquinaNyx.vue?vue&type=style&index=0&id=63b25c57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b25c57",
  null
  
)

export default component.exports